import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { History, LocationState } from 'history';

import { API_STATUS_CODE } from '../enums/apiStatusCode';
import { ROUTES } from '../router/routes';

export const rootMiddleware =
  (history: History<LocationState>): Middleware =>
  (api: MiddlewareAPI) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      const errorStatus = 'originalStatus' in action.payload ? action.payload.originalStatus : action.payload.status;

      switch (errorStatus) {
        case API_STATUS_CODE.UNAUTHORIZED:
          history.push(ROUTES.ERROR_401);
          break;
        case API_STATUS_CODE.FORBIDDEN:
          history.push(ROUTES.ERROR_403);
          break;
      }
    }

    return next(action);
  };
